import React, { useEffect, useState } from 'react'

import { useSearchParams } from 'react-router-dom'

import { AccountTab } from '@/features/account/types'

import AccountPageUI from './AccountPageUI'

const AccountPage: React.FC = () => {
	const [searchParams, setSearchParams] = useSearchParams()
	const [activeTab, setActiveTab] = useState<AccountTab>(
		(searchParams.get('tab') as AccountTab | null) || 'user-profile'
	)

	useEffect(() => {
		if (activeTab !== activeTab) {
			setSearchParams({ tab: activeTab }, { replace: true })
		}
	}, [activeTab, activeTab, setSearchParams])

	useEffect(() => {
		if (activeTab && activeTab !== activeTab) {
			setActiveTab(activeTab)
		}
	}, [activeTab])

	return <AccountPageUI activeTab={activeTab} setActiveTab={setActiveTab} />
}

export default AccountPage
